export default __webpack_public_path__ + "static/media/phonebooth_lightOn.d787f8c9.webp";